import "./number_array_type_extension.js";

export function initNumberArrayExtension(): void {
    _initNumberArrayExtensionPrototype();
}

function _initNumberArrayExtensionPrototype(): void {
}